import { SORT_DIRECTION } from '@/constants/sort';
type SortDirection = (typeof SORT_DIRECTION)[keyof typeof SORT_DIRECTION];

export const toggleSortDirection = (direction: SortDirection) =>
  direction === SORT_DIRECTION.ASC ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC;
